export default __webpack_public_path__ + "static/media/NeonFood_Croissant.6baf7e41.gif";